import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";
import { ToastProgrammatic as Toast } from "buefy";
export default class RAMSurveyService {
  private httpClient = makeHttpClient();
  getSurveyData(customer_id: any, id: any) {
    const url =
      `${env.surveyUrl}ramsurvey/?customer_id=` + customer_id + "&id=" + id;
    return _unwrapAxiosResponse(this.httpClient.get<RAMSurveyService>(url));
  }
  saveSurveyData(
    customer_id: any,
    surveyId: any,
    form: any,
    status: any,
    packaging_id: any
  ) {
    const data = {
      customer_id: customer_id,
      id: packaging_id,
      result_data: form,
      status: status,
      survey: surveyId
    };
    if (!packaging_id) {
      const url = `${env.surveyUrl}ramsurvey/submit/survey/`;
      return _unwrapAxiosResponse(
        this.httpClient.post<RAMSurveyService>(url, JSON.stringify(data))
      );
    } else {
      const url =
        `${env.surveyUrl}ramsurvey/submit/survey/` + packaging_id + "/";
      return _unwrapAxiosResponse(
        this.httpClient.put<RAMSurveyService>(url, JSON.stringify(data))
      );
    }
  }
  getSurveyById(id: any) {
    const url = `${env.surveyUrl}ramsurvey/${id}/view/`;
    return _unwrapAxiosResponse(this.httpClient.get<RAMSurveyService>(url));
  }
  getSurveyProductData(customer_id: any, query: any) {
    const url =
      `${env.surveyUrl}ramsurvey/products/?customer_id=` + customer_id + query;
    return _unwrapAxiosResponse(this.httpClient.get<RAMSurveyService>(url));
  }
  getAllProductList(customer_id: any) {
    const url =
      `${env.surveyUrl}ramsurvey/allproducts?customer_id=` + customer_id;
    return _unwrapAxiosResponse(this.httpClient.get<RAMSurveyService>(url));
  }
  createSurveyProduct(customer_id: any, form: any) {
    const data = {
      customer: customer_id,
      product_name: form.product_name,
      product_number: form.product_number,
      product_barcode: form.product_barcode
    };
    const url = `${env.surveyUrl}ramsurvey/products/`;
    return _unwrapAxiosResponse(
      this.httpClient.post<RAMSurveyService>(url, JSON.stringify(data))
    );
  }
  updateSurveyProduct(customer_id: any, form: any) {
    const data = {
      customer: customer_id,
      id: form.id,
      product_name: form.product_name,
      product_number: form.product_number,
      product_barcode: form.product_barcode
    };
    const url = `${env.surveyUrl}ramsurvey/products/` + form.id + "/";
    return _unwrapAxiosResponse(
      this.httpClient.put<RAMSurveyService>(url, JSON.stringify(data))
    );
  }
  getPackingList(customer_id: any) {
    const url =
      `${env.surveyUrl}ramsurvey/packinglist/?customer_id=` + customer_id;
    return _unwrapAxiosResponse(this.httpClient.get<RAMSurveyService>(url));
  }

  getSurveyPackingData(customer_id: any, query: any) {
    const url =
      `${env.surveyUrl}ramsurvey/submit/survey/?customer_id=` +
      customer_id +
      query;
    return _unwrapAxiosResponse(this.httpClient.get<RAMSurveyService>(url));
  }

  downloadSurvey(customerId: any, surveyId: any) {
    const url =
      `${env.surveyUrl}ramsurvey/submit/downloadpdf?customer_id=` +
      customerId +
      `&survey_id=` +
      surveyId;
    // const successToast = Toast.open({
    //   indefinite: true,
    //   message: "Download in Progress!",
    //   type: "is-success"
    // });
    this.httpClient.get(url, { responseType: "blob" }).then(({ data }) => {
      const downloadUrl = window.URL.createObjectURL(new Blob([data]));

      const link = document.createElement("a");

      link.href = downloadUrl;
      link.setAttribute("download", "survey.pdf"); //any other extension
      document.body.appendChild(link);
      link.click();
      link.remove();
    });
    // successToast.close();
  }
}
